import { Platform } from 'react-native';

export const isWeb = () => Platform.OS === 'web';
export const isNative = () => ['android', 'ios'].includes(Platform.OS);
export const isIos = () => Platform.OS === 'ios';
export const isAndroid = () => Platform.OS === 'android';
